export enum ListIndexMethod {
  MostSoldModels = 'getMostSoldModels',
  BestPerformingInstallers = 'getBestPerformingInstallers',
  LeadsToBeChecked = 'getLeadsToBeChecked',
  LongestResponseTime = 'getLongestResponseTime',
  Installer = 'getInstallerStatus',
}
